module.exports = __webpack_public_path__ + "media/images/covid/icons/thermograph-60bea200094190b07285ef13b3bc33e2.svg";